import React, {useEffect, useState} from 'react';
import {useNavigate} from "react-router-dom";

import styles from './ErrorPage.module.scss';
import error from '../../constants/images/error.svg';
import MainButtonTransparentBackground
    from "../../components/UI/MainButtonTransparentBackground/MainButtonTransparentBackground";
import MainButtonWithBackground from "../../components/UI/MainButtonWithBackground/MainButtonWithBackground";
import {MAIN_ROUTES} from "../../routing/main_routes";

const ErrorPage = () => {
    const navigate = useNavigate();
    const [displayWidth, setDisplayWidth] = useState(window.innerWidth);

    const isCleaner = !!JSON.parse(localStorage.getItem('isCleaner'));
    const token = JSON.parse(localStorage.getItem('token'));

    const handleResize = () => {
        setDisplayWidth(window.innerWidth);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleNavigateToMain = () => {
        if (isCleaner && token?.access) {
            navigate(MAIN_ROUTES.ALL_CLEANING_REQUESTS);
        } else if (!isCleaner && token?.access) {
            navigate(MAIN_ROUTES.MAIN)
        } else {
            navigate(MAIN_ROUTES.LOGIN);
        }
    }

    return (
        <div className={styles.errorPage}>
            <img src={error} alt="cleaner icon"/>
            <div className={styles.errorPage_title}>
                <h1>Сторінку не знайдено</h1>
                <div>
                    <p>Сторінка, яку ви шукаєте, не існує. </p>
                    <p>Ось кілька корисних посилань:</p>
                </div>
            </div>
            <div className={styles.errorPage_buttons}>
                <MainButtonTransparentBackground
                    onClick={() => navigate(-1)}
                    width={displayWidth > 425 ? 'auto' : '100%'}
                    type={'button'} // submit or button
                    text={'Повернутись Назад'}
                    condition={false} // is disabled
                />
                <MainButtonWithBackground
                    onClick={handleNavigateToMain}
                    width={displayWidth > 425 ? 'auto' : '100%'}
                    type={'button'} // submit or button
                    text={'На Головну'}
                    condition={false} // is disabled
                />
            </div>
        </div>
    );
};

export default ErrorPage;
